import GeoJSON from 'ol/format/GeoJSON';
import { ColormapDetails } from '/modules/vecdoor/ollayers';
import HeatmapLayer from 'ol/layer/Heatmap.js';
import { ElevationImageLayer, DiffImageLayer, ShaderImageLayer, MagImageLayer, GeoJsonLayer, GeoJsonHeatMapLayer, GeoJsonClusterLayer, BingMapsLayer } from '/modules/vecdoor/ollayers';
import { ModalDialog } from '/modules/vecdoor/uitools';
import { uid } from 'uid';

export class CheckBoxItemFactory {
    static GetItem(obj) {
        switch (obj.type) {
            case undefined:
                throw new Error("Item type is undefined.");
            case 'CheckBoxItem':
                return new CheckBoxItem(obj);
            case 'CheckBoxItemElevationImageLayer':
                return new CheckBoxItemElevationImageLayer(obj);
            case 'CheckBoxItemRadarImageLayer':
                return new CheckBoxItemRadarImageLayer(obj);
            case 'CheckBoxItemShaderImageLayer':
                return new CheckBoxItemShaderImageLayer(obj);
            case 'CheckBoxDiffImageLayer':
                return new CheckBoxDiffImageLayer(obj);
            case 'CheckBoxItemGeoJsonLayer':
                return new CheckBoxItemGeoJsonLayer(obj);
            case 'CheckBoxItemGeoJsonHeatmapLayer':
                return new CheckBoxItemGeoJsonHeatmapLayer(obj);
            case 'CheckBoxItemGeoJsonCluster':
                return new CheckBoxItemGeoJsonCluster(obj);
            case 'CheckBoxItemBingMaps':
                return new CheckBoxItemBingMaps(obj);
            default:
                throw new Error("Unknown type: " + obj.type);
        }

    }
}

export class CheckBoxItem {
    children = [];
    type = 'CheckBoxItem';
    constructor(params) {
        if (params.name === undefined) { throw new Error("name is undefined."); }
        this.name = params.name;
        this.description = (params.description) ? params.description : '';
        const id = uid();
        this.cbId = (params.cbId) ? params.cbId : id;
        this.cbValue = (params.cbValue) ? params.cbValue : id;
        this.parentId = (params.parentId) ? params.parentId : uid();
        this.isExpanded = (params.isExpanded !== undefined) ? params.isExpanded : true;
        if (params.children !== undefined) {
            params.children.forEach(child => {
                this.addChild(CheckBoxItemFactory.GetItem(child));
            });
        }
    }

    static fromJson(jsonStr) {
        const obj = JSON.parse(jsonStr);
        const cbItem = CheckBoxItemFactory.GetItem(obj);
        return cbItem;
    }
    /**
     * 
     * @param {CheckBoxItem} child 
     */
    addChild(child) {
        child.parentId = this.cbId;
        this.children.push(child);
    }
    /**
     * 
     * @param {string} childId 
     */
    removeChild(childId) { this.children = this.children.filter(child => child.cbId == childId) }

    /**
     * 
     * @returns {HTMLLIElement} li
     */
    createElements() {
        const li = document.createElement('li');
        li.className = 'checkBox_li';
        const italics = document.createElement('i');
        italics.innerHTML = '- ' + this.name;

        const infoButton = document.createElement('label');
        infoButton.innerHTML = ' &#9432; ';
        infoButton.addEventListener('click', (e) => {
            const infoModal = new ModalDialog();
            infoModal.open(this.createInfoModelElements());
        });
        li.appendChild(infoButton);

        const hasLayerChildren = this.children.some(child => child.type != this.type);
        const checkBox = document.createElement('input')
        if (hasLayerChildren) {
            checkBox.type = 'checkbox';
            if (this.children.every(child => (child.isChecked !== undefined && child.isChecked))) {
                checkBox.checked = true;
            }
            checkBox.addEventListener('change', (e) => {
                checkBox.checked = e.currentTarget.checked;
                this.children.forEach((child) => {
                    child.isChecked = checkBox.checked;
                    const el = document.getElementById(child.cbId);
                    if (el.checked != child.isChecked) { el.click(); }
                });
            });
        }

        const childUl = document.createElement('ul');
        childUl.className = 'checkbox_ul';
        childUl.id = this.cbId;
        childUl.style.display = 'block';

        li.appendChild(italics);
        li.appendChild(infoButton);
        if (hasLayerChildren) { li.appendChild(checkBox); }
        li.appendChild(childUl);

        const id = this.cbId;
        italics.addEventListener('click', (e) => {
            if (e.currentTarget.innerHTML[0] === '+') {
                showChildUL();
            }
            else {
                hideChildUL();
            }
        });
        if (!this.isExpanded) { hideChildUL(); }
        this.children.forEach((child) => childUl.appendChild(child.createElements()));
        return li;

        function showChildUL() {
            { childUl.style.display = 'block'; }
            italics.innerHTML = italics.innerHTML.replace('+', '-');
        }

        function hideChildUL() {
            childUl.style.display = 'none';
            italics.innerHTML = italics.innerHTML.replace('-', '+');
        }
    }

    createInfoModelElements() {
        const div = document.createElement('div');
        const h4 = document.createElement('h4');
        h4.innerHTML = this.name;
        const p = document.createElement('p');
        p.innerHTML = this.description;
        div.appendChild(h4);
        div.appendChild(p);
        return div;
    }

}

export class CheckBoxItemElevationImageLayer extends CheckBoxItem {
    type = 'CheckBoxItemElevationImageLayer';
    #layer = null;
    constructor(params) {
        super(params);
        if (params.urls === undefined) { throw new Error("Define urls"); }
        this.isChecked = (params.isChecked) ? params.isChecked : false;
        this.urls = params.urls;
        this.colormapDetails = (params.colormapDetails) ? new ColormapDetails(params.colormapDetails) : new ColormapDetails();
    }

    getLayer() {return this.#layer;}
    setLayer(layer) {this.#layer = layer;}
    /**
     *
     * @returns {HTMLLIElement} li
     */
    createElements() {
        if (this.children.length > 0) { throw new Error('Unsupported. CheckBoxItemElevationImageLayer cannot have children.'); }

        const li = document.createElement('li');
        li.className = 'checkBox_li';

        const label = document.createElement('label');
        label.innerHTML = this.name;

        const checkBox = document.createElement('input');
        checkBox.type = 'checkbox';
        checkBox.checked = this.isChecked;
        checkBox.value = this.cbValue;
        checkBox.id = this.cbId;
        checkBox.data = this;
        checkBox.addEventListener('change', (e) => {
            checkBox.data.isChecked = e.currentTarget.checked;
            if (checkBox.checked) { e.currentTarget.data.addLayer(); }
            else { checkBox.data.removeLayer(e.currentTarget.data); }
        });
        if (this.isChecked) { this.addLayer(); }

        const infoButton = document.createElement('label');
        infoButton.innerHTML = ' &#9432; ';
        infoButton.addEventListener('click', (e) => {
            const infoModal = new ModalDialog();
            infoModal.open(checkBox.data.createInfoModelElements());
        });

        label.appendChild(checkBox);
        li.appendChild(label);
        li.appendChild(infoButton);

        if (this.urls.length == 1)
        {
            const downloadButton = document.createElement('a');
            downloadButton.href = '#';
            downloadButton.classList = 'fa fa-download';
            downloadButton.addEventListener('click', (e) => 
            {
                
                const link = document.createElement('a');
                link.href = this.urls[0];
                link.click();
                URL.revokeObjectURL(link.href);
            });
            li.appendChild(downloadButton);
        }
        return li;
    }

    addLayer() {
        
        const layer = new ElevationImageLayer(
            {
                name: this.cbId,
                urls: this.urls,
                colormapDetails: this.colormapDetails,
            }
        );
        this.setLayer(layer);
        this.getLayer().addLayer();
    }
    removeLayer() {
        window.map.layerManager.removeLayer(this.cbId);
    }

    createInfoModelElements() {
        const div = document.createElement('div');
        const h4 = document.createElement('h4');
        h4.innerHTML = this.name;
        const p = document.createElement('p');
        p.innerHTML = this.description;
        div.appendChild(h4);
        div.appendChild(p);

        const colormapControls = this.colormapDetails.createColormapDetailsElements(this.getLayer());
        div.appendChild(colormapControls);
        return div;
    }
}
export class CheckBoxItemRadarImageLayer extends CheckBoxItemElevationImageLayer {
    type = 'CheckBoxItemRadarImageLayer';
    constructor(params) {
        super(params);
        if (params.urls === undefined) { throw new Error("Define urls"); }
        this.isChecked = (params.isChecked) ? params.isChecked : false;
        this.urls = params.urls;
        this.colormapDetails = (params.colormapDetails) ? new ColormapDetails(params.colormapDetails) :
            new ColormapDetails(
                {
                    values: [3, 11],
                    range: [[-1, 11]],
                    colormap: 'greys',
                });
    }


    addLayer() {
        const layer = new MagImageLayer(
            {
                name: this.cbId,
                urls: this.urls,
                colormapDetails: this.colormapDetails,
            }
        );
        this.setLayer(layer);
        layer.addLayer();
    }
}

export class CheckBoxItemShaderImageLayer extends CheckBoxItemElevationImageLayer {
    type = 'CheckBoxItemShaderImageLayer';
    constructor(params) {
        super(params);
        if (params.urls === undefined) { throw new Error("Define urls"); }
        this.isChecked = (params.isChecked) ? params.isChecked : false;
        this.urls = params.urls;
        this.colormapDetails = (params.colormapDetails) ? new ColormapDetails(params.colormapDetails) :
            new ColormapDetails(
                {
                    values: [0, 255],
                    range: [[0, 255]],
                    colormap: 'greys',
                });
    }


    addLayer() {
        const layer = new ShaderImageLayer(
            {
                name: this.cbId,
                urls: this.urls,
                colormapDetails: this.colormapDetails,
            }
        );
        this.setLayer(layer);
        layer.addLayer();
    }
}

export class CheckBoxDiffImageLayer extends CheckBoxItemElevationImageLayer {
    type = 'CheckBoxDiffImageLayer';
    constructor(params) {
        params.urls = [];
        super(params);

        this.cbId_band1 = (params.cbId_band1) ? params.cbId_band1 : null;
        this.cbId_band2 = (params.cbId_band2) ? params.cbId_band2 : null;

    }

    addSourceItemIds(sourceLayers) {
        if (sourceLayers.length != 2) { throw new Error('Should be 2 layers used as input.'); }
        [this.cbId_band1, this.cbId_band2] = addSourceItems.map(screen.cbId);

    }

    addLayer() {
        const intervalId = setInterval(() => {
            const el1 = document.getElementById(this.cbId_band1);
            const el2 = document.getElementById(this.cbId_band2);
            if (el1 !== null && el2 !== null) {
                clearInterval(intervalId);
                const band1 = document.getElementById(this.cbId_band1).data;
                const band2 = document.getElementById(this.cbId_band2).data;
                this.urls = band1.urls.concat(band2.urls);
                const layer = new DiffImageLayer(
                    {
                        name: this.cbId,
                        urls: this.urls,
                        colormapDetails: this.colormapDetails,
                        srcColormapDetails: [band1.colormapDetails, band2.colormapDetails],
                    }
                );
                this.setLayer(layer);
                layer.addLayer();
            }
        }, 100); // Check every 100 milliseconds
    }
}

export class CheckBoxItemGeoJsonLayer extends CheckBoxItem {
    type = 'CheckBoxItemGeoJsonLayer';
    #layer = null;
    constructor(params) {
        super(params);
        this.isChecked = (params.isChecked) ? params.isChecked : false;
        if (params.url === undefined) {throw new Error('No URL defined for layer.');}
        this.url = params.url;
    }

    getLayer() {return this.#layer;}
    setLayer(layer) {this.#layer = layer;}

    /**
     *
     * @returns {HTMLLIElement} li
     */
    createElements() {
        if (this.children.length > 0) { throw new Error('Unsupported. CheckBoxItemElevationImageLayer cannot have children.'); }

        const li = document.createElement('li');
        li.className = 'checkBox_li';

        const label = document.createElement('label');
        label.innerHTML = this.name;

        const checkBox = document.createElement('input');
        checkBox.type = 'checkbox';
        checkBox.checked = this.isChecked;
        checkBox.value = this.cbValue;
        checkBox.id = this.cbId;
        checkBox.data = this;
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        {
            label.innerHTML = label.innerHTML += ' - disabled for mobile';
            checkBox.disabled = true;
            this.isChecked = false;
        }
    
        checkBox.addEventListener('change', (e) => {
            this.isChecked = e.currentTarget.checked;
            if (checkBox.checked) { e.currentTarget.data.addLayer(); }
            else { checkBox.data.removeLayer(e.currentTarget.data); }
        });
        if (this.isChecked) { this.addLayer(); }

        const infoButton = document.createElement('label');
        infoButton.innerHTML = ' &#9432; ';
        infoButton.addEventListener('click', (e) => {
            const infoModal = new ModalDialog();
            infoModal.open(this.createInfoModelElements());
        });

        label.appendChild(checkBox);
        li.appendChild(label);
        li.appendChild(infoButton);
        return li;
    }

    addLayer() {
        const layer = new GeoJsonLayer(
            {
                name: this.cbId,
                url: this.url,
            }
        );
        this.setLayer(layer);
        layer.addLayer();
    }

    removeLayer() {
        this.getLayer().removeLayer();
    }

    createInfoModelElements() {
        const div = document.createElement('div');
        const h4 = document.createElement('h4');
        h4.innerHTML = this.name;
        const p = document.createElement('p');
        p.innerHTML = this.description;
        div.appendChild(h4);
        div.appendChild(p);

        // const colormapControls = this.colormapDetails.createColormapDetailsElements(this.#layer);
        // div.appendChild(colormapControls);
        return div;
    }
}

export class CheckBoxItemGeoJsonHeatmapLayer extends CheckBoxItemGeoJsonLayer {
    type = 'CheckBoxItemGeoJsonHeatmapLayer';
    constructor(params) {
        super(params);
        this.blur = (params.blur) ?? 1;
        this.radius = (params.radius) ?? 1;
    }

    addLayer() {
        const layer = new GeoJsonHeatMapLayer(
            {
                name: this.cbId,
                url: this.url,
            }
        );
        this.setLayer(layer);
        layer.addLayer();
    }
       
}

export class CheckBoxItemBingMaps extends CheckBoxItem {
    type = 'CheckBoxItemBingMaps';
    #layer = null;
    constructor(params) {
        super(params);
//        if (params.urls === undefined) { throw new Error("Define urls"); }
        this.isChecked = (params.isChecked) ? params.isChecked : false;
        this.colormapDetails = (params.colormapDetails) ? new ColormapDetails(params.colormapDetails) : new ColormapDetails();
    }

    getLayer() {return this.#layer;}
    setLayer(layer) {this.#layer = layer;}
    /**
     *
     * @returns {HTMLLIElement} li
     */
    createElements() {
        if (this.children.length > 0) { throw new Error('Unsupported. CheckBoxItemBingMaps cannot have children.'); }

        const li = document.createElement('li');
        li.className = 'checkBox_li';

        const label = document.createElement('label');
        label.innerHTML = this.name;

        const checkBox = document.createElement('input');
        checkBox.type = 'checkbox';
        checkBox.checked = this.isChecked;
        checkBox.value = this.cbValue;
        checkBox.id = this.cbId;
        checkBox.data = this;
        checkBox.addEventListener('change', (e) => {
            checkBox.data.isChecked = e.currentTarget.checked;
            if (checkBox.checked) { e.currentTarget.data.addLayer(); }
            else { checkBox.data.removeLayer(e.currentTarget.data); }
        });
        if (this.isChecked) { this.addLayer(); }

        const infoButton = document.createElement('label');
        infoButton.innerHTML = ' &#9432; ';
        infoButton.addEventListener('click', (e) => {
            const infoModal = new ModalDialog();
            infoModal.open(checkBox.data.createInfoModelElements());
        });

        label.appendChild(checkBox);
        li.appendChild(label);
        li.appendChild(infoButton);
        return li;
    }

    addLayer() {
        
        const layer = new BingMapsLayer(
            {
                name: this.cbId,
            }
        );
        this.setLayer(layer);
        this.getLayer().addLayer();
    }
    removeLayer() {
        this.getLayer().removeLayer();
    }

    createInfoModelElements() {
        const div = document.createElement('div');
        const h4 = document.createElement('h4');
        h4.innerHTML = this.name;
        const p = document.createElement('p');
        p.innerHTML = this.description;
        div.appendChild(h4);
        div.appendChild(p);

        const colormapControls = this.colormapDetails.createColormapDetailsElements(this.getLayer());
        div.appendChild(colormapControls);
        return div;
    }
}


export class CheckBoxItemGeoJsonCluster extends CheckBoxItemGeoJsonLayer {
    type = 'CheckBoxItemGeoJsonCluster';
    constructor(params) {
        super(params);
        this.fillColor = (params.fillColor) ? params.fillColor : 'rgba(0, 175, 181, 0.5)';
        this.transitionZoom = (params.transitionZoom) ? params.transitionZoom : 8;
    }

    addLayer() {
        const layer = new GeoJsonClusterLayer(
            {
                name: this.cbId,
                url: this.url,
                transitionZoom: this.transitionZoom,
                fillColor: this.fillColor,
            }
        );
        this.setLayer(layer);
        layer.addLayer();
    }
}

